import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRINT_TEMPLATE,
  DELETE_PRINT_TEMPLATE,
  UPDATE_PRINT_TEMPLATE,
  ADD_NEW_PRINT_TEMPLATE,
} from "./actionType";

import {
  getPrintTemplateSuccess,
  getPrintTemplateFail,
  deletePrintTemplateSuccess,
  deletePrintTemplateFail,
  updatePrintTemplateSuccess,
  updatePrintTemplateFail,
  addPrintTemplateSuccess,
  addPrintTemplateFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getPrintTemplateApi,
  updatePrintTemplateApi,
  deletePrintTemplateApi,
  addNewPrintTemplateApi
} from "../../helpers/backend_helper";

function* getPrintTemplate({ payload: printTemplate }) {
  try {
    const response = yield call(getPrintTemplateApi, printTemplate);
    yield put(getPrintTemplateSuccess(GET_PRINT_TEMPLATE, response.data));
  } catch (error) {
    yield put(getPrintTemplateFail(GET_PRINT_TEMPLATE, error));
  }
}

function* onUpdatePrintTemplate({ payload: printTemplate }) {
  try {
    const response = yield call(updatePrintTemplateApi, printTemplate);
    yield put(updatePrintTemplateSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updatePrintTemplateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePrintTemplate({ payload: printTemplate }) {
  try {
    const response = yield call(deletePrintTemplateApi, printTemplate);
    yield put(deletePrintTemplateSuccess({ printTemplate, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePrintTemplateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPrintTemplate({ payload: printTemplate }) {
  try {
    const response = yield call(addNewPrintTemplateApi, printTemplate);
    yield put(addPrintTemplateSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPrintTemplateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPrintTemplate() {
  yield takeEvery(GET_PRINT_TEMPLATE, getPrintTemplate);
}

export function* watchUpdatePrintTemplate() {
  yield takeEvery(UPDATE_PRINT_TEMPLATE, onUpdatePrintTemplate);
}

export function* watchDeletePrintTemplate() {
  yield takeEvery(DELETE_PRINT_TEMPLATE, onDeletePrintTemplate);
}

export function* watchAddNewPrintTemplate() {
  yield takeEvery(ADD_NEW_PRINT_TEMPLATE, onAddNewPrintTemplate);
}

function* printTemplateSaga() {
  yield all([
    fork(watchGetPrintTemplate),
    fork(watchDeletePrintTemplate),
    fork(watchUpdatePrintTemplate),
    fork(watchAddNewPrintTemplate)
  ]);
}

export default printTemplateSaga;
